import { useEffect } from 'react';
// import Swiper, { Autoplay, Navigation, Pagination } from 'swiper';
// import 'swiper/css';
// import 'swiper/css/navigation';
// import 'swiper/css/pagination';
import { Constants } from '@/constants/constants';
import { Remote } from '@/api/remote';
import { ApiConstant } from '@/constants/api_constants';
import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { IEventList, IFaqList, INoticeList } from '@/pages/home/interface/home.interface';
import { useNavigate } from 'react-router';
import { NAV_PATH } from '@/router/constants';
import { V } from 'react-router/dist/development/fog-of-war-DU_DzpDb';

gsap.registerPlugin(ScrollTrigger);
// Swiper.use([Autoplay, Navigation, Pagination]);
const MAIN_NOTICE_MAX_LEN = 5;
const MAIN_FAQ_MAX_LEN = 5;

/** 홈 화면 커스텀 훅 */
const useHome = () => {
	const navigate = useNavigate();

	/** 메인 화면 스크롤 이벤트 함수 */
	const mainAddScrollTrigger = () => {
		const bannerTitle = document.querySelectorAll('.main-banner-inner .title-group');
		gsap.killTweensOf(bannerTitle);
		gsap.set(bannerTitle, { duration: 0, y: 60, opacity: 1 });
		gsap.to(bannerTitle, {
			scrollTrigger: {
				trigger: bannerTitle,
				start: '0% 100%',
				end: '100% 100%',
				scrub: 1
			},
			y: 0,
			opacity: 1,
			duration: 0.6,
			ease: 'Cubic.easeOut'
		});

		const featureTitle = document.querySelector('.main-feature-inner .title-group');
		gsap.killTweensOf(featureTitle);
		gsap.set(featureTitle, { duration: 0, y: 60, opacity: 0 });
		gsap.to(featureTitle, {
			scrollTrigger: {
				trigger: featureTitle,
				start: '0% 100%',
				end: '100% 100%',
				scrub: 1
			},
			y: 0,
			opacity: 1,
			duration: 0.6,
			ease: 'Cubic.easeOut'
		});

		const featureCard1 = document.querySelector('.main-feature-inner .feature1');
		gsap.killTweensOf(featureCard1);
		gsap.to(featureCard1, { duration: 0, y: 60, opacity: 0 });
		gsap.to(featureCard1, {
			scrollTrigger: {
				trigger: featureCard1,
				start: '0% 100%',
				end: '100% 100%',
				scrub: 1
			},
			y: 0,
			opacity: 1,
			duration: 0.6,
			ease: 'Cubic.easeOut'
		});

		const featureCard2 = document.querySelector('.main-feature-inner .feature2');
		gsap.killTweensOf(featureCard2);
		gsap.to(featureCard2, { duration: 0, y: 60, opacity: 0 });
		gsap.to(featureCard2, {
			scrollTrigger: {
				trigger: featureCard2,
				start: '0% 100%',
				end: '100% 100%',
				scrub: 1
			},
			y: 0,
			opacity: 1,
			duration: 0.6,
			ease: 'Cubic.easeOut'
		});

		const diffTitle = document.querySelector('.main-different-feature-inner .title-group');
		gsap.killTweensOf(diffTitle);
		gsap.set(diffTitle, { duration: 0, y: 60, opacity: 0 });
		gsap.to(diffTitle, {
			scrollTrigger: {
				trigger: diffTitle,
				start: '0% 100%',
				end: '100% 100%',
				scrub: 1
			},
			y: 0,
			opacity: 1,
			duration: 0.6,
			ease: 'Cubic.easeOut'
		});

		const diffCardList = document.querySelectorAll('.main-different-feature-inner .item-list');
		const diffCardLen = diffCardList.length;
		gsap.killTweensOf(diffCardList);
		gsap.set(diffCardList, { duration: 0, y: 60, opacity: 0 });
		for (let i = 0; i < diffCardLen; i++) {
			const item = diffCardList[i];
			gsap.to(item, {
				scrollTrigger: {
					trigger: item,
					start: '0% 100%',
					end: '100% 100%',
					scrub: 1
				},
				y: 0,
				opacity: 1,
				duration: 0.4,
				ease: 'Cubic.easeOut',
				delay: 0.15 * i
			});
		}

		const freeTitle = document.querySelector('.main-free-inner .title-group');
		gsap.killTweensOf(freeTitle);
		gsap.set(freeTitle, { duration: 0, y: 60, opacity: 0 });
		gsap.to(freeTitle, {
			scrollTrigger: {
				trigger: freeTitle,
				start: '0% 100%',
				end: '100% 100%',
				scrub: 1
			},
			y: 0,
			opacity: 1,
			duration: 0.6,
			ease: 'Cubic.easeOut'
		});

		const freeBanner = document.querySelector('.main-free-inner .main-free-price');
		gsap.killTweensOf(freeBanner);
		gsap.set(freeBanner, { duration: 0, y: 60, opacity: 0 });
		gsap.to(freeBanner, {
			scrollTrigger: {
				trigger: freeBanner,
				start: '0% 100%',
				end: '100% 100%',
				scrub: 1
			},
			y: 0,
			opacity: 1,
			duration: 0.6,
			ease: 'Cubic.easeOut'
		});

		const serviceTitle = document.querySelector('.main-service-inner > .title-group');
		gsap.killTweensOf(serviceTitle);
		gsap.set(serviceTitle, { duration: 0, y: 60, opacity: 0 });
		gsap.to(serviceTitle, {
			scrollTrigger: {
				trigger: serviceTitle,
				start: '0% 100%',
				end: '100% 100%',
				scrub: 1
			},
			y: 0,
			opacity: 1,
			duration: 0.6,
			ease: 'Cubic.easeOut'
		});

		const serviceItemList = document.querySelectorAll('.main-service-inner .service-list li');
		const serviceItemListLen = serviceItemList.length;
		gsap.killTweensOf(serviceItemList);
		gsap.set(serviceItemList, { duration: 0, y: 60, opacity: 0 });
		for (let i = 0; i < serviceItemListLen; i++) {
			const item = serviceItemList[i];
			gsap.to(item, {
				scrollTrigger: {
					trigger: item,
					start: '0% 100%',
					end: '100% 100%',
					scrub: 1
				},
				y: 0,
				opacity: 1,
				duration: 0.4,
				ease: 'Cubic.easeOut',
				delay: 0.15 * i
			});
		}

		const businessTitle = document.querySelector('.main-business-inner > .title-group');
		gsap.killTweensOf(businessTitle);
		gsap.set(businessTitle, { duration: 0, y: 60, opacity: 0 });
		gsap.to(businessTitle, {
			scrollTrigger: {
				trigger: businessTitle,
				start: '0% 100%',
				end: '100% 100%',
				scrub: 1
			},
			y: 0,
			opacity: 1,
			duration: 0.6,
			ease: 'Cubic.easeOut'
		});

		const businessItemList = document.querySelectorAll('.main-business-inner .business-list li');
		const businessItemListLen = businessItemList.length;
		gsap.killTweensOf(businessItemList);
		gsap.set(businessItemList, { duration: 0, y: 60, opacity: 0 });
		for (let i = 0; i < businessItemListLen; i++) {
			const item = businessItemList[i];
			gsap.to(item, {
				scrollTrigger: {
					trigger: item,
					start: '0% 100%',
					end: '100% 100%',
					scrub: 1
				},
				y: 0,
				opacity: 1,
				duration: 0.4,
				ease: 'Cubic.easeOut',
				delay: 0.15 * i
			});
		}

		const erpTitle = document.querySelector('.main-erp-inner .title-group');
		gsap.killTweensOf(erpTitle);
		gsap.set(erpTitle, { duration: 0, y: 60, opacity: 0 });
		gsap.to(erpTitle, {
			scrollTrigger: {
				trigger: erpTitle,
				start: '0% 100%',
				end: '100% 100%',
				scrub: 1
			},
			y: 0,
			opacity: 1,
			duration: 0.6,
			ease: 'Cubic.easeOut'
		});

		const erpItemList = document.querySelectorAll('.main-erp-inner .erp-list li');
		const erpItemListLen = erpItemList.length;
		gsap.killTweensOf(erpItemList);
		gsap.set(erpItemList, { duration: 0, y: 60, opacity: 0 });
		for (let i = 0; i < erpItemListLen; i++) {
			const item = erpItemList[i];
			gsap.to(item, {
				scrollTrigger: {
					trigger: item,
					start: '0% 100%',
					end: '100% 100%',
					scrub: 1
				},
				y: 0,
				opacity: 1,
				duration: 0.4,
				ease: 'Cubic.easeOut',
				delay: 0.15 * i
			});
		}

		const boardNoticeTitle = document.querySelector('.main-cs-inner .title-group');
		gsap.killTweensOf(boardNoticeTitle);
		gsap.set(boardNoticeTitle, { y: 60, opacity: 0 });
		gsap.to(boardNoticeTitle, {
			scrollTrigger: {
				trigger: boardNoticeTitle,
				start: '0% 100%',
				end: '100% 100%',
				scrub: 1
			},
			y: 0,
			opacity: 1,
			duration: 0.6,
			ease: 'Cubic.easeOut'
		});

		const boardNotice = document.querySelector('.main-cs-inner .main-board-group');
		gsap.killTweensOf(boardNotice);
		gsap.set(boardNotice, { y: 60, opacity: 0 });
		gsap.to(boardNotice, {
			scrollTrigger: {
				trigger: boardNotice,
				start: '0% 100%',
				end: '100% 100%',
				scrub: 1
			},
			y: 0,
			opacity: 1,
			duration: 0.6,
			ease: 'Cubic.easeOut'
		});

		const qnaTitle = document.querySelector('.main-qna-inner .txt-holder');
		gsap.killTweensOf(qnaTitle);
		gsap.set(qnaTitle, { y: 60, opacity: 0 });
		gsap.to(qnaTitle, {
			scrollTrigger: {
				trigger: qnaTitle,
				start: '0% 100%',
				end: '100% 100%',
				scrub: 1
			},
			y: 0,
			opacity: 1,
			duration: 0.6,
			ease: 'Cubic.easeOut'
		});

		const qnaBtn = document.querySelector('.main-qna-inner .btn');
		gsap.killTweensOf(qnaBtn);
		gsap.set(qnaBtn, { y: 60, opacity: 0 });
		gsap.to(qnaBtn, {
			scrollTrigger: {
				trigger: qnaBtn,
				start: '0% 100%',
				end: '100% 100%',
				scrub: 1
			},
			y: 0,
			opacity: 1,
			duration: 0.6,
			ease: 'Cubic.easeOut',
			delay: 0.2
		});

		// const eventTitle = document.querySelector('.main-event-inner > .title-group');
		// gsap.killTweensOf(eventTitle);
		// gsap.set(eventTitle, { y: 100, opacity: 0 });
		// gsap.to(eventTitle, {
		// 	scrollTrigger: {
		// 		trigger: eventTitle,
		// 		start: '70% 100%',
		// 		end: '100% 100%',
		// 		scrub: 1
		// 	},
		// 	y: 0,
		// 	opacity: 1,
		// 	duration: 0.6,
		// 	ease: 'Cubic.easeOut'
		// });

		// const eventNotice = document.querySelector('.main-event-inner > .event-group');
		// gsap.killTweensOf(eventNotice);
		// gsap.set(eventNotice, { y: 200, opacity: 0 });
		// gsap.to(eventNotice, {
		// 	scrollTrigger: {
		// 		trigger: eventNotice,
		// 		start: '40% 100%',
		// 		end: '100% 100%',
		// 		scrub: 1
		// 	},
		// 	y: 0,
		// 	opacity: 1,
		// 	duration: 0.6,
		// 	ease: 'Cubic.easeOut'
		// });
	};

	/** 메인 화면 이벤트 api 함수 */
	const mainGetDataEvent = async () => {
		const jsonData = {
			onGoingPage: 1,
			onGoingSize: 999,
			endedPage: 1,
			endedSize: 1
		};
		try {
			const response = await Remote.Api.get(ApiConstant.mgmtEvent.list, jsonData);
			if (response.code !== Constants.apiSuccess) {
				alert(response.message);
				return;
			}

			mainEventSetListEle(response.content.onGoingEvntList);
		} catch (error) {
			console.error('Error fetching event data:', error);
		}
	};

	const mainEventSetListEle = (list: IEventList[]) => {
		const boardListCon = document.querySelector('.event-group .swiper-wrapper');
		const len = list.length;
		let ele = Constants.empty;
		for (let i = 0; i < len; i++) {
			ele += `<div class="img-banner swiper-slide">
                    <a class="event-link" data-evnt-id="${list[i].evntId}"  href="${NAV_PATH.CUSTOMER_SUPPORT.EVENT_DETAIL}?evntId=${list[i].evntId}&endYn=N">
                      ${list[i].evntBnnr}
                    </a>
                  </div>`;
		}
		if (boardListCon) {
			boardListCon.innerHTML = ele;
			const links = document.querySelectorAll('.event-link');
			links.forEach(link => {
				link.addEventListener('click', event => {
					event.preventDefault();
					const target = event.currentTarget as HTMLElement;
					const evntId = target.getAttribute('data-evnt-id');
					if (evntId) {
						navigate(`${NAV_PATH.CUSTOMER_SUPPORT.EVENT_DETAIL}?evntId=${evntId}&endYn=N`);
					}
				});
			});
		}

		// new Swiper('.event-group .swiper-container', {
		// 	slidesPerView: 3,
		// 	spaceBetween: 15,
		// 	speed: 500,
		// 	navigation: {
		// 		nextEl: '.event-group .swiper-button-next',
		// 		prevEl: '.event-group .swiper-button-prev'
		// 	}
		// });
	};

	const mainNoticeSetListEle = (list: INoticeList[]) => {
		const boardListCon = document.querySelector('.main-board-list.notice');
		const template = boardListCon?.getAttribute('data-template');
		const len = list.length <= MAIN_NOTICE_MAX_LEN ? list.length : MAIN_NOTICE_MAX_LEN;
		let ele = '';

		for (let i = 0; i < len; i++) {
			ele += template;
		}

		if (boardListCon) {
			boardListCon.innerHTML = ele;
			mainNoticeSetList(list);
		}
	};

	const mainNoticeSetList = (list: INoticeList[]) => {
		const len = list.length <= MAIN_NOTICE_MAX_LEN ? list.length : MAIN_NOTICE_MAX_LEN;
		const listEle = document.querySelectorAll('.main-board-list.notice li');

		for (let i = 0; i < len; i++) {
			const title = list[i].anncmtTitl;
			const anncmtId = list[i].anncmtId;
			const titleElement = listEle[i]?.querySelector('.title') as HTMLElement;
			if (titleElement) {
				titleElement.innerText = title;
			}
			const btn = listEle[i]?.querySelector('a') as HTMLAnchorElement;
			if (btn) {
				btn.addEventListener('click', e => {
					e.preventDefault();
					navigate(`${NAV_PATH.CUSTOMER_SUPPORT.NOTICE_DETAIL}?anncmtId=${anncmtId}`);
				});

				if (list[i].newYn === Constants.yes) {
					btn.classList.add('new');
				}
			}
		}
	};

	/** 메인 화면 공지사항 api 함수 */
	const mainGetDataNotice = async () => {
		const jsonData = {
			page: 1,
			size: MAIN_NOTICE_MAX_LEN
		};
		try {
			const response = await Remote.Api.get(ApiConstant.mgmtAnncmt.list, jsonData);
			if (response.code !== Constants.apiSuccess) {
				alert(response.message);
				return;
			}
			mainNoticeSetListEle(response.content.anncmtList);
		} catch (error) {
			console.log('error', error);
		}
	};

	const mainFaqSetListEle = (list: IFaqList[]) => {
		const boardListCon = document.querySelector('.main-board-list.faq');
		const template = boardListCon?.getAttribute('data-template');
		const len = list.length <= MAIN_FAQ_MAX_LEN ? list.length : MAIN_FAQ_MAX_LEN;
		let ele = '';

		for (let i = 0; i < len; i++) {
			ele += template;
		}
		if (boardListCon) {
			boardListCon.innerHTML = ele;
			mainFaqSetList(list);
		}
	};

	const mainFaqSetList = (list: IFaqList[]) => {
		const len = list.length <= MAIN_FAQ_MAX_LEN ? list.length : MAIN_FAQ_MAX_LEN;
		const listEle = document.querySelectorAll('.main-board-list.faq li');
		for (let i = 0; i < len; i++) {
			const titleElement = listEle[i]?.querySelector('.title');
			const btn = listEle[i]?.querySelector('a');
			if (titleElement) {
				titleElement.innerHTML = `<span>Q.</span> ${list[i].faqTitl}`;
			}

			if (btn) {
				const faqId = list[i].faqId;
				const faqCtgryId = list[i].faqCtgryId;
				btn.addEventListener('click', e => {
					e.preventDefault();
					navigate(`${NAV_PATH.CUSTOMER_SUPPORT.FAQ}?faqId=${faqId}&faqCtgryId=${faqCtgryId}`);
				});

				if (list[i].newYn === Constants.yes) {
					btn.classList.add('new');
				}
			}
		}
	};
	/** 메인 화면 Faq api 함수 */
	const mainGetDataFaq = async () => {
		const page = 1;
		const jsonData = {
			faqCtgryNm: Constants.empty
		};
		try {
			const response = await Remote.Api.get(`${ApiConstant.mgmtFaq.list}/${page}/${MAIN_FAQ_MAX_LEN}`, jsonData);
			if (response.code !== Constants.apiSuccess) {
				alert(response.message);
				return;
			}
			mainFaqSetListEle(response.content.list);
		} catch (error) {
			console.error('error', error);
		}
	};

	useEffect(() => {
		mainAddScrollTrigger();
		mainGetDataEvent();
		mainGetDataFaq();
		mainGetDataNotice();
	}, []);
};
export default useHome;
